module.exports = __webpack_public_path__ + "adb103f4ee5c4b6a4f0452b30e70c963.MP3";